import React from "react";
import { Box, Typography, LinearProgress, Tooltip } from "@mui/material";

export default function ProgressBarMUI({ label, value, total, color }) {
  const percentage = total > 0 ? (value / total) * 100 : 0;

  return (
    <Box mb={1.5}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={0.5}
      >
        <Tooltip title={label} arrow>
          <Typography
            variant="body2"
            fontWeight="medium"
            sx={{
              maxWidth: "70%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {label}
          </Typography>
        </Tooltip>
        <Typography variant="body2" color="text.secondary">
          {value}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={percentage}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: "#e5e7eb",
          "& .MuiLinearProgress-bar": {
            backgroundColor: color,
            borderRadius: 4,
            transition: "transform 0.3s ease",
          },
        }}
      />
    </Box>
  );
}
